import { computed } from 'vue';
import { formatToLocalTime } from '@/shared/common';
import { SLA_MESSAGE_DATE_FORMAT } from '@/shared/quote/constants/quoterSla.constant';

export function useQuoterSLAMessage(props) {
  const message = computed(() => {
    if (props.customerMessage) {
      return props.customerMessage;
    }

    if (props.immediate) {
      return 'Tu dinero llega al instante';
    }

    if (props.shortTime) {
      return 'Tu dinero llegará en minutos';
    }

    if (props.minutesDate) {
      return `Tu dinero debería llegar en minutos o durante el ${formatToLocalTime(props.estimatedSla, SLA_MESSAGE_DATE_FORMAT)}`;
    }

    if (props.estimatedSla) {
      return `Tu dinero llegará máximo el ${formatToLocalTime(props.estimatedSla, SLA_MESSAGE_DATE_FORMAT)}`;
    }

    return 'Calculando...';
  });

  return { message };
}
